import React from 'react'
import ReactDOM from 'react-dom';

const TableBodyRow = (props) => {
  const { user, data, className, handleDeactivateGroup } = props

  const dealerCounts = data.active == true ? <a href={`/backend/users?by_group_id=${data.id}`}>{data.user_count}</a> : data.user_count
  const disableGroup = user.role === 'readonlyadmin' ? 'true' : ''

  return (
    <tr>
      { user.role.includes('superadmin') ? ( <td>{data.account_name}</td>) : null }
      <td>{data.name}</td>
      <td><b>{dealerCounts}</b></td>
      { user.role.includes('readonly') ? null :
        (
         <td>
           <button disabled={disableGroup} className={className} id={data.id} onClick={handleDeactivateGroup}>
             {
               data.active == true ? "Deactivate" : "Reactivate"
             }
           </button>
         </td>
        )
      }
    </tr>
  )
};

export default TableBodyRow;
